import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";
import { formatNumber } from "../../../components/formatNumber";

const BudgetTemplateForm = (props) => {
  const [seasonlist, setSeasonlist] = useState(null);
  const [areaUnits, setAreaUnits] = useState([]);
  const [seasonId, setSeasonId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeId, setEmployeeId] = useState();
  const [cropId, setCropId] = useState([]);
  const [cropList, setCropList] = useState([]);
  const [templateName, setTemplateName] = useState();
  const [templateArea, setTemplateArea] = useState(1);
  const [serviceProducts, setServiceProducts] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState("");
  const [selectedProductDetails, setSelectedProductDetails] = useState(null);
  const [productUnitId, setProductUnitId] = useState("");
  const [unitCost, setUnitCost] = useState(); // Cost / Unit
  const [markup, setMarkup] = useState(); // Mark-Up %
  const [numUnits, setNumUnits] = useState();
  const [adminRows, setAdminRows] = useState([]);
  const [unitId, setUnitId] = useState("");
  const [providedBy, setProvidedBy] = useState("");
  const [farmingStage, setFarmingStage] = useState("");
  const [ranchId, setRanchId] = useState();
  const [ranchData, setRanchData] = useState([]);

  const [editIndex, setEditIndex] = useState(null);
  const [editRowData, setEditRowData] = useState({});

  const [regionData, setRegionData] = useState([]);
  const [regionId, setRegionId] = useState();

  const [budgetData, setBudgetData] = useState([]);

  const [filterdBudget, setFilterdBudget] = useState([]);
  const [budgetId, setBudgetId] = useState(0);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  const handleProductChange = (e) => {
    const id = e.target.value;
    setSelectedProductId(id);

    const selected = serviceProducts.find((p) => p.productId === parseInt(id));
    if (selected) {
      setSelectedProductDetails(selected);
      //console.log(selected);
    } else {
      setSelectedProductDetails("");
    }
  };

  const costPerUnitFarmers =
    unitCost && markup
      ? (
        (parseFloat(unitCost) * parseFloat(markup)) / 100 +
        parseFloat(unitCost)
      ).toFixed(2)
      : 0;

  const totalCostCompanys =
    unitCost && numUnits
      ? (parseFloat(unitCost) * parseFloat(numUnits)).toFixed(2)
      : 0;

  const totalCostFarmers =
    costPerUnitFarmers && numUnits
      ? (parseFloat(costPerUnitFarmers) * parseFloat(numUnits)).toFixed(2)
      : 0;

  const markupValues =
    totalCostCompanys && totalCostFarmers
      ? parseFloat(totalCostFarmers) - parseFloat(totalCostCompanys).toFixed(2)
      : 0;

  const { sendRequest: getcrop } = useHttp();
  const fillCrop = () => {
    getcrop(
      {
        url: "/api/crops/",
      },
      (res) => {
        if (res) {
          setCropList(res);
        }
      }
    );
  };

  useEffect(() => {
    fillCrop();
  }, [getcrop]);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employeeByUsecase/?orgId=${localStorage.getItem(
          "orgId"
        )}&useCase=Procurement`,
      },
      (data) => {
        var emplist = data.output;

        setEmployeeData(emplist);
      }
    );
  }, []);

  const [units, setUnits] = useState([]);
  const [allunits, setAllUnits] = useState([]);
  const { sendRequest: getUnits } = useHttp();

  const getUnitsDetail = () => {
    getUnits(
      {
        url: `/api/units?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setAllUnits(res);

          const filterAreaUnits =
            res && res.filter((itm) => itm.unitTypeName === "Area");
          setAreaUnits(filterAreaUnits);
        }
      }
    );
  };
  useEffect(() => {
    getUnitsDetail();
  }, [getUnits]);

  const getProductUnitsDetail = () => {
    const filterNumberUnits =
      allunits &&
      allunits.filter(
        (itm) => itm.unitTypeId == selectedProductDetails?.unitTypeId
      );

    setUnits(filterNumberUnits);
  };

  useEffect(() => {
    getProductUnitsDetail();
  }, [selectedProductDetails]);

  const { sendRequest: getSeason } = useHttp();
  useEffect(() => {
    getSeason(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem(
          "orgId"
        )}&&createdBy=${localStorage.getItem("id")}`,
      },
      (data) => {
        setSeasonlist(data);
      }
    );
  }, [getSeason]);

  const { sendRequest: getRanch } = useHttp();
  useEffect(() => {
    getRanch(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRanchData(data);
      }
    );
  }, [getRanch]);
  const { sendRequest: getBudget } = useHttp();
  useEffect(() => {
    getBudget(
      {
        url: `/api/budgetTemplate/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setBudgetData(data);
      }
    );
  }, [getBudget]);

  useEffect(() => {
    if (cropId >= 1) {
      const filterdBudgetData = budgetData?.filter(
        (itm) => itm.cropId == cropId
      );

      console.log(filterdBudgetData);

      setFilterdBudget(filterdBudgetData);
    }
  }, [cropId]);

  useEffect(() => {
    if (budgetId > 1) {
      const filterdInputData = budgetData.filter(
        (itm) => itm.farmerInputTemplateId == budgetId
      );
      setAdminRows(
        (filterdInputData[0]?.budgetTemplateProductDetails || []).map(
          (item) => ({
            ...item,
            costPerUnit: item.cost,
            costPerUnitFarmer: item.costFarmer,
            markupValue: item.markUpValue,
          })
        )
      ); // Step 3
    }
  }, [budgetId]);

  const { sendRequest: FillServiceProduct } = useHttp();
  useEffect(() => {
    FillServiceProduct(
      {
        url: `/api/fillServiceAndProductforBudget/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setServiceProducts(data);
      }
    );
  }, [FillServiceProduct]);

  const handleAddRow = () => {
    if (
      !selectedProductId ||
      !providedBy ||
      !unitCost ||
      !markup ||
      !numUnits ||
      !farmingStage ||
      !productUnitId
    ) {
      toast.error("Please fill in all required fields before adding.");
      return;
    }

    const selectedUnit = units?.find(
      (u) => u.unitId === parseInt(productUnitId)
    );

    const newRow = {
      productId: parseInt(selectedProductId),
      productName: selectedProductDetails?.productName || "",
      productSubTypeName: selectedProductDetails?.productSubTypeName || "",
      productTypeName: selectedProductDetails?.productTypeName || "",
      farmingStage: farmingStage,
      productUsedfor: "Field Inputs",
      providedBy: providedBy || "",
      quantity: parseFloat(numUnits) || 0,
      unitId: parseInt(productUnitId),
      unitName: selectedUnit?.unitName || "",
      costPerUnit: parseFloat(unitCost),
      markUp: parseFloat(markup),
      costPerUnitFarmer: parseFloat(costPerUnitFarmers),
      totalCostCompany: parseFloat(totalCostCompanys),
      totalCostFarmer: parseFloat(totalCostFarmers),
      markupValue: parseFloat(markupValues).toFixed(2),
      totalCostByArea: parseFloat(totalCostFarmers),
    };

    setAdminRows([...(adminRows || []), newRow]);

    setSelectedProductId("");
    setSelectedProductDetails(null);
    setUnitCost("");
    setMarkup("");
    setNumUnits("");
    setProductUnitId("");
    setProvidedBy("");
    setFarmingStage("");
  };

  const handleDeleteRow = (index) => {
    const updatedRows = adminRows.filter((_, i) => i !== index);
    setAdminRows(updatedRows);
  };

  const { sendRequest: postBudgetTemplate } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    if (!adminRows || adminRows?.length === 0) {
      toast.error("Please add at least one input.");
      return;
    }

    const orgId = parseInt(localStorage.getItem("orgId"));
    const createdBy = parseInt(localStorage.getItem("id"));

    const budgetTemplateProductDetails = adminRows?.map((item) => ({
      ...(props.update && {
        farmerInputTemplateDetailId: item.farmerInputTemplateDetailId,
      }),
      farmingStage: item.farmingStage || "",
      providedBy: item.providedBy || "",
      regionId: parseInt(regionId) || 0,
      quantity: item.quantity || 0,
      cost: item.costPerUnit?.toString() || "0",
      markUp: item.markUp?.toString() || "0",
      costFarmer: item.costPerUnitFarmer || "0",
      productUsedfor: "Field Inputs",
      totalCostCompany: item.totalCostCompany || 0,
      totalCostFarmer: item.totalCostFarmer || 0,
      markUpValue: item.markupValue || 0,
      totalCostByArea: item.totalCostByArea || 0,
      productId: item.productId || 0,
      unitId: item.unitId || 0,
      seasonId: seasonId,
      orgId: orgId,
      createdBy: createdBy,
    }));

    const inputs = {
      budgetTemplateProductDetails,
      templateDate: selectedDate,
      templateName: templateName,

      fieldExecutiveId: employeeId,
      templateArea: parseInt(templateArea) || 0,
      status: 1,
      templateAreaUnitId: parseInt(unitId) || 0,
      cropId: parseInt(cropId) || 0,
      // ranchId: parseInt(ranchId) || 0,
      ranchId: ranchId ? parseInt(ranchId) : null,
      seasonId: parseInt(seasonId) || 0,
      employeeId: parseInt(employeeId) || 0,
      orgId: orgId,
      createdBy: createdBy,
    };

    if (props.update) {
      inputs["farmerInputTemplateId"] = props.update.farmerInputTemplateId;
    }
    console.log("inputs to Submit:", inputs);

    postBudgetTemplate(
      {
        url: "/api/budgetTemplate/",
        method: props.update ? "PUT" : "POST",
        body: props.update ? [inputs] : inputs,
      },
      (res) => {
        toast.success(
          `Farmer Budget Template ${props.update ? "Updated" : "Added"}`
        );
        props.addForm(false);
      }
    );
  };

  const handleEditClick = (index) => {
    setEditIndex(index);
    setEditRowData({ ...adminRows[index] });
  };

  const handleEditChange = (e, field) => {
    const value = e.target.value;
    const newEditRow = { ...editRowData, [field]: value };

    if (["quantity", "costPerUnit", "markUp"].includes(field)) {
      const quantity = parseFloat(newEditRow.quantity) || 0;
      const costPerUnit = parseFloat(newEditRow.costPerUnit) || 0;
      const markUp = parseFloat(newEditRow.markUp) || 0;

      const costPerUnitFarmer = (
        (costPerUnit * markUp) / 100 +
        costPerUnit
      ).toFixed(2);
      const totalCostCompany = (costPerUnit * quantity).toFixed(2);
      const totalCostFarmer = (
        parseFloat(costPerUnitFarmer) * quantity
      ).toFixed(2);
      const markupValue = (
        parseFloat(totalCostFarmer) - parseFloat(totalCostCompany)
      ).toFixed(2);

      newEditRow.costPerUnitFarmer = parseFloat(costPerUnitFarmer);
      newEditRow.totalCostCompany = parseFloat(totalCostCompany);
      newEditRow.totalCostFarmer = parseFloat(totalCostFarmer);
      newEditRow.markupValue = parseFloat(markupValue);
      newEditRow.totalCostByArea = parseFloat(totalCostFarmer);
    }

    setEditRowData(newEditRow);
  };

  const handleSaveEdit = () => {
    const quantity = parseFloat(editRowData.quantity) || 0;
    const costPerUnit = parseFloat(editRowData.costPerUnit) || 0;
    const markUp = parseFloat(editRowData.markUp) || 0;

    const costPerUnitFarmer = (
      (costPerUnit * markUp) / 100 +
      costPerUnit
    ).toFixed(2);

    const totalCostCompany = (costPerUnit * quantity).toFixed(2);
    const totalCostFarmer = (parseFloat(costPerUnitFarmer) * quantity).toFixed(
      2
    );

    const markupValue = (
      parseFloat(totalCostFarmer) - parseFloat(totalCostCompany)
    ).toFixed(2);

    const updatedRows = [...adminRows];
    updatedRows[editIndex] = {
      ...editRowData,
      quantity,
      costPerUnit,
      markUp,
      costPerUnitFarmer: parseFloat(costPerUnitFarmer),
      totalCostCompany: parseFloat(totalCostCompany),
      totalCostFarmer: parseFloat(totalCostFarmer),
      markupValue: parseFloat(markupValue),
      totalCostByArea: parseFloat(totalCostFarmer),
    };

    setAdminRows(updatedRows);
    setEditIndex(null);
  };

  const { sendRequest: getDetailView } = useHttp();

  useEffect(() => {
    if (props.update) {
      const farmerInputTemplateId =
        props.update && props.update.farmerInputTemplateId;

      getDetailView(
        {
          url: `/api/budgetTemplate/?orgId=${localStorage.getItem(
            "orgId"
          )}&farmerInputTemplateId=${farmerInputTemplateId}`,
        },
        (res) => {
          console.log("Detail", res);

          setSeasonId(res.seasonId);
          setCropId(res.cropId);
          setEmployeeId(res.fieldExecutiveId);
          setTemplateName(res.templateName);
          setTemplateArea(res.templateArea);
          setUnitId(res.templateAreaUnitId);
          if (res.templateDate) {
            const m = moment(res.templateDate, "DD/MM/YYYY");
            setSelectedDate(m.format("YYYY-MM-DD"));
          }
          setRanchId(res.ranchId);
          setAdminRows(
            res.budgetTemplateProductDetails.map((item) => ({
              ...item,
              costPerUnit: item.cost || 0,
              costPerUnitFarmer: item.costFarmer || 0,
              markupValue: item.markUpValue || 0,
            }))
          );
        }
      );
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        {" "}
        <div>&nbsp;</div>
        <section className="content">
          <div className="card card-default">
            <form
              style={{ margin: "10px" }}
              className="mt-3"
              onSubmit={submitHandler}
            >
              <div className="card-header">
                <h3 className="card-title">Farmer Budget Templates Form </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => props.addForm(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="p-6 space-y-6">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        {" "}
                        <label>Date</label>
                        <input
                          type="date"
                          className="form-control"
                          max={currentDate}
                          value={selectedDate}
                          required
                          onChange={handleDateChange}
                        />
                      </div>
                    </div>{" "}
                    <div className="col-md-3">
                      <div className="form-group">
                        {" "}
                        <label>Employee</label>
                        <select
                          className="form-control"
                          value={employeeId}
                          required
                          onChange={(e) => {
                            setEmployeeId(e.target.value);
                          }}
                        >
                          <option value="">Select</option>
                          {employeeData &&
                            employeeData.map((x) => (
                              <option key={x.userId} value={x.empId}>
                                {x.employeeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>{" "}
                    <div className="col-md-3">
                      <div className="form-group">
                        {" "}
                        <label>Crop</label>
                        <select
                          className="form-control"
                          value={cropId}
                          required
                          onChange={(e) => {
                            setCropId(e.target.value);
                          }}
                        >
                          <option value="">Select</option>
                          {cropList &&
                            cropList.map((x) => (
                              <option key={x.cropId} value={x.cropId}>
                                {x.cropName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>{" "}
                    <div className="col-md-3">
                      <div className="form-group">
                        {" "}
                        <label>Season</label>
                        <select
                          className="form-control"
                          required
                          value={seasonId}
                          onChange={(e) => {
                            setSeasonId(e.target.value);
                          }}
                        >
                          <option value="">Select</option>
                          {seasonlist &&
                            seasonlist.map((x) => (
                              <option key={x.seasonId} value={x.seasonId}>
                                {x.seasonName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Ranch</label>
                        <select
                          id="ranch"
                          className="form-control"
                          required
                          value={ranchId}
                          onChange={(e) => setRanchId(e.target.value || 0)}
                        >
                          <option value="">Select</option>
                          {ranchData &&
                            ranchData.map((x) => (
                              <option key={x.ranchId} value={x.ranchId}>
                                {x.ranchName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        {" "}
                        <label>Budget Template Name</label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          value={templateName}
                          onChange={(e) => {
                            setTemplateName(e.target.value);
                          }}
                        />
                      </div>
                    </div>{" "}
                    <div className="col-md-3">
                      <div className="form-group">
                        {" "}
                        <label>Input Template Area</label>
                        <input
                          type="number"
                          className="form-control"
                          required
                          value={templateArea}
                          min={1}
                          onChange={(e) => {
                            setTemplateArea(e.target.value);
                          }}
                        />{" "}
                      </div>
                    </div>{" "}
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Unit</label>
                        <select
                          className="form-control"
                          required
                          value={unitId}
                          onChange={(e) => setUnitId(e.target.value)}
                        >
                          <option value="">Select</option>
                          {areaUnits &&
                            areaUnits.map((x) => (
                              <option key={x.unitId} value={x.unitId}>
                                {x.unitName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>{" "}
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Copy Budget From</label>
                        <select
                          className="form-control"
                          value={budgetId}
                          onChange={(e) => setBudgetId(e.target.value)}
                        >
                          <option value="">Select</option>
                          {filterdBudget &&
                            filterdBudget?.map((x) => (
                              <option
                                key={x.farmerInputTemplateId}
                                value={x.farmerInputTemplateId}
                              >
                                {x.templateName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>{" "}
                  </div>

                  <div>
                    <h3 className="text-lg font-medium mt-6">Inputs</h3>

                    {/* <table className="table table-bordered table-responsive">
                      <thead>
                        <tr>
                          {[
                            "Sr No.",
                            "Product",
                            "Product Sub Type",
                            "Product Type",
                            "Farming Stage",
                            "Provided By",
                            "Number of Units",
                            "Unit",
                            "Cost/Unit",
                            "Mark-Up (%)",
                            "Cost/Unit (Farmer)",
                            "Total Cost (Company)",
                            "Total Cost (Farmer)",
                            "Mark-Up Value",
                            "Action",
                          ].map((header, idx) => (
                            <th key={idx}>{header}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>

                          <td>
                            <select
                              className="form-control"
                              style={{ width: "150px" }}
                              value={selectedProductId}
                              onChange={handleProductChange}
                            >
                              <option value="">Select</option>
                              {serviceProducts.map((product) => (
                                <option
                                  key={product.productId}
                                  value={product.productId}
                                >
                                  {product.productName}
                                </option>
                              ))}
                            </select>
                          </td>

                          <td>
                            {selectedProductDetails?.productSubTypeName || ""}
                          </td>
                          <td>
                            {selectedProductDetails?.productTypeName || ""}
                          </td>
                          <td>
                            {" "}
                            <select
                              className="form-control"
                              style={{ width: "100px" }}
                              value={farmingStage}
                              onChange={(e) => setFarmingStage(e.target.value)}
                            >
                              <option value="">Select</option>
                              <option value="Planting">Planting</option>
                              <option value="Fertilizer">Fertilizer</option>
                              <option value="Chemical">Chemical</option>
                              <option value="Organic">Organic</option>
                              <option value="Harvest">Harvest</option>
                              <option value="Cultural">Cultural</option>
                              <option value="Ground Prep">Ground Prep</option>
                              <option value="Programmatic">Programmatic</option>
                            </select>
                          </td>

                          <td>
                            <select
                              className="form-control"
                              style={{ width: "100px" }}
                              value={providedBy}
                              onChange={(e) => setProvidedBy(e.target.value)}
                            >
                              <option value="">Select</option>
                              <option value="Company">Company</option>
                              <option value="Farmer">Farmer</option>
                            </select>
                          </td>

                          <td>
                            <input
                              className="form-control"
                              type="Text"
                              value={numUnits}
                              onChange={(e) => setNumUnits(e.target.value)}
                              style={{ width: "100px" }}
                              min="0"
                            />
                          </td>

                          <td>
                            <select
                              className="form-control"
                              style={{ width: "100px" }}
                              value={productUnitId}
                              onChange={(e) => setProductUnitId(e.target.value)}
                            >
                              <option value="">Select</option>
                              {units &&
                                units.map((x) => (
                                  <option key={x.unitId} value={x.unitId}>
                                    {x.unitName}
                                  </option>
                                ))}
                            </select>
                          </td>

                          <td>
                            <input
                              className="form-control"
                              type="Text"
                              value={unitCost}
                              onChange={(e) => setUnitCost(e.target.value)}
                              style={{ width: "100px" }}
                              min={0}
                            />
                          </td>

                          <td>
                            <input
                              className="form-control"
                              type="Text"
                              value={markup}
                              onChange={(e) => setMarkup(e.target.value)}
                              style={{ width: "100px" }}
                              min={0}
                            />
                          </td>

                          <td>
                            {parseFloat(costPerUnitFarmers).toFixed(2) || "0"}
                          </td>
                          <td>
                            {parseFloat(totalCostCompanys).toFixed(2) || "0"}
                          </td>
                          <td>
                            {parseFloat(totalCostFarmers).toFixed(2) || "0"}
                          </td>
                          <td>{parseFloat(markupValues).toFixed(2) || "0"}</td>
                        </tr>
                        <tr>
                          <td colSpan="15" className="text-right">
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={handleAddRow}
                            >
                              + Add
                            </button>
                          </td>
                        </tr>

                        {adminRows?.map((row, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{row.productName}</td>
                            <td>{row.productSubTypeName}</td>
                            <td>{row.productTypeName}</td>

                            <td>
                              {editIndex === idx ? (
                                <select
                                  className="form-control"
                                  value={editRowData.farmingStage}
                                  onChange={(e) =>
                                    handleEditChange(e, "farmingStage")
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="Planting">Planting</option>
                                  <option value="Fertilizer">Fertilizer</option>
                                  <option value="Chemical">Chemical</option>
                                  <option value="Organic">Organic</option>
                                  <option value="Harvest">Harvest</option>
                                  <option value="Cultural">Cultural</option>
                                  <option value="Ground Prep">
                                    Ground Prep
                                  </option>
                                  <option value="Programmatic">
                                    Programmatic
                                  </option>
                                </select>
                              ) : (
                                row.farmingStage
                              )}
                            </td>
                            <td>
                              {editIndex === idx ? (
                                <select
                                  className="form-control"
                                  value={editRowData.providedBy}
                                  onChange={(e) =>
                                    handleEditChange(e, "providedBy")
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="Company">Company</option>
                                  <option value="Farmer">Farmer</option>
                                </select>
                              ) : (
                                row.providedBy
                              )}
                            </td>
                            <td>
                              {editIndex === idx ? (
                                <input
                                  type="number"
                                  className="form-control"
                                  value={editRowData.quantity}
                                  onChange={(e) =>
                                    handleEditChange(e, "quantity")
                                  }
                                />
                              ) : (
                                row.quantity
                              )}
                            </td>
                            <td>{row.unitName}</td>
                            <td>
                              {editIndex === idx ? (
                                <input
                                  type="number"
                                  className="form-control"
                                  value={editRowData.costPerUnit}
                                  onChange={(e) =>
                                    handleEditChange(e, "costPerUnit")
                                  }
                                />
                              ) : (
                                row.costPerUnit
                              )}
                            </td>
                            <td>
                              {editIndex === idx ? (
                                <input
                                  type="number"
                                  className="form-control"
                                  value={editRowData.markUp}
                                  onChange={(e) =>
                                    handleEditChange(e, "markUp")
                                  }
                                />
                              ) : (
                                row.markUp
                              )}
                            </td>
                            <td>{row.costPerUnitFarmer}</td>
                            <td>{row.totalCostCompany}</td>
                            <td>{row.totalCostFarmer}</td>
                            <td>{row.markupValue}</td>
                            <td>
                              {editIndex === idx ? (
                                <>
                                  <button
                                    className="btn btn-sm "
                                    onClick={handleSaveEdit}
                                    type="button"
                                  >
                                    <i className="fas fa-check" />
                                  </button>
                                  &nbsp;
                                  <button
                                    className="btn btn-sm condary"
                                    onClick={() => setEditIndex(null)}
                                    type="button"
                                  >
                                    <i className="fas fa-times" />
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="btn btn-sm"
                                    onClick={() => handleEditClick(idx)}
                                    type="button"
                                  >
                                    <i className="fas fa-edit" />
                                  </button>
                                  &nbsp;
                                  <button
                                    className="btn btn-sm"
                                    onClick={() => handleDeleteRow(idx)}
                                    type="button"
                                  >
                                    <i className="fas fa-trash" />
                                  </button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table> */}

                    <table className="table table-bordered table-responsive">
                      <thead>
                        <tr>
                          {[
                            "Sr No.",
                            "Product",
                            "Product Sub Type",
                            "Product Type",
                            "Farming Stage",
                            "Provided By",
                            "Number of Units",
                            "Unit",
                            "Cost/Unit",
                            "Mark-Up (%)",
                            "Cost/Unit (Farmer)",
                            "Total Cost (Company)",
                            "Total Cost (Farmer)",
                            "Mark-Up Value",
                            "Action",
                          ].map((header, idx) => (
                            <th key={idx}>{header}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {/* Entry Row */}
                        <tr>
                          <td>1</td>
                          <td>
                            <select
                              className="form-control"
                              style={{ width: "150px" }}
                              value={selectedProductId}
                              onChange={handleProductChange}
                            >
                              <option value="">Select</option>
                              {serviceProducts.map((product) => (
                                <option
                                  key={product.productId}
                                  value={product.productId}
                                >
                                  {product.productName}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            {selectedProductDetails?.productSubTypeName || ""}
                          </td>
                          <td>
                            {selectedProductDetails?.productTypeName || ""}
                          </td>
                          <td>
                            <select
                              className="form-control"
                              style={{ width: "100px" }}
                              value={farmingStage}
                              onChange={(e) => setFarmingStage(e.target.value)}
                            >
                              <option value="">Select</option>
                              <option value="Planting">Planting</option>
                              <option value="Fertilizer">Fertilizer</option>
                              <option value="Chemical">Chemical</option>
                              <option value="Organic">Organic</option>
                              <option value="Harvest">Harvest</option>
                              <option value="Cultural">Cultural</option>
                              <option value="Ground Prep">Ground Prep</option>
                              <option value="Programmatic">Programmatic</option>
                            </select>
                          </td>
                          <td>
                            <select
                              className="form-control"
                              style={{ width: "100px" }}
                              value={providedBy}
                              onChange={(e) => setProvidedBy(e.target.value)}
                            >
                              <option value="">Select</option>
                              <option value="Company">Company</option>
                              <option value="Farmer">Farmer</option>
                            </select>
                          </td>
                          <td>
                            <input
                              className="form-control"
                              type="Text"
                              value={numUnits}
                              onChange={(e) => setNumUnits(e.target.value)}
                              style={{ width: "100px" }}
                              min="0"
                            />
                          </td>
                          <td>
                            <select
                              className="form-control"
                              style={{ width: "100px" }}
                              value={productUnitId}
                              onChange={(e) => setProductUnitId(e.target.value)}
                            >
                              <option value="">Select</option>
                              {units &&
                                units.map((x) => (
                                  <option key={x.unitId} value={x.unitId}>
                                    {x.unitName}
                                  </option>
                                ))}
                            </select>
                          </td>
                          <td>
                            <input
                              className="form-control"
                              type="Text"
                              value={unitCost}
                              onChange={(e) => setUnitCost(e.target.value)}
                              style={{ width: "100px" }}
                              min={0}
                            />
                          </td>
                          <td>
                            <input
                              className="form-control"
                              type="Text"
                              value={markup}
                              onChange={(e) => setMarkup(e.target.value)}
                              style={{ width: "100px" }}
                              min={0}
                            />
                          </td>
                          <td>
                            {parseFloat(costPerUnitFarmers).toFixed(2) || "0"}
                          </td>
                          <td>
                            {parseFloat(totalCostCompanys).toFixed(2) || "0"}
                          </td>
                          <td>
                            {parseFloat(totalCostFarmers).toFixed(2) || "0"}
                          </td>
                          <td>{parseFloat(markupValues).toFixed(2) || "0"}</td>
                        </tr>
                        <tr>
                          <td colSpan="15" className="text-right">
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={handleAddRow}
                            >
                              + Add
                            </button>
                          </td>
                        </tr>

                        {/* Rows Display and Edit */}
                        {adminRows?.map((row, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{row.productName}</td>
                            <td>{row.productSubTypeName}</td>
                            <td>{row.productTypeName}</td>
                            {/* FarmingStage */}
                            <td>
                              {editIndex === idx ? (
                                <select
                                  className="form-control"
                                  value={editRowData.farmingStage}
                                  onChange={(e) =>
                                    handleEditChange(e, "farmingStage")
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="Planting">Planting</option>
                                  <option value="Fertilizer">Fertilizer</option>
                                  <option value="Chemical">Chemical</option>
                                  <option value="Organic">Organic</option>
                                  <option value="Harvest">Harvest</option>
                                  <option value="Cultural">Cultural</option>
                                  <option value="Ground Prep">
                                    Ground Prep
                                  </option>
                                  <option value="Programmatic">
                                    Programmatic
                                  </option>
                                </select>
                              ) : (
                                row.farmingStage
                              )}
                            </td>
                            {/* ProvidedBy */}
                            <td>
                              {editIndex === idx ? (
                                <select
                                  className="form-control"
                                  value={editRowData.providedBy}
                                  onChange={(e) =>
                                    handleEditChange(e, "providedBy")
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="Company">Company</option>
                                  <option value="Farmer">Farmer</option>
                                </select>
                              ) : (
                                row.providedBy
                              )}
                            </td>
                            {/* Number of Units */}
                            <td>
                              {editIndex === idx ? (
                                <input
                                  type="number"
                                  className="form-control"
                                  value={editRowData.quantity}
                                  onChange={(e) =>
                                    handleEditChange(e, "quantity")
                                  }
                                />
                              ) : (
                                row.quantity
                              )}
                            </td>
                            {/* Unit */}
                            <td>{row.unitName}</td>
                            {/* Cost/Unit */}
                            <td>
                              {editIndex === idx ? (
                                <input
                                  type="number"
                                  className="form-control"
                                  value={editRowData.costPerUnit}
                                  onChange={(e) =>
                                    handleEditChange(e, "costPerUnit")
                                  }
                                />
                              ) : (
                                formatNumber(row.costPerUnit)
                              )}
                            </td>
                            {/* Mark-Up (%) */}
                            <td>
                              {editIndex === idx ? (
                                <input
                                  type="number"
                                  className="form-control"
                                  value={editRowData.markUp}
                                  onChange={(e) =>
                                    handleEditChange(e, "markUp")
                                  }
                                />
                              ) : (
                                formatNumber(row.markUp)
                              )}
                            </td>
                            {/* Calculated Fields */}
                            <td>
                              {editIndex === idx
                                ? editRowData.costPerUnitFarmer
                                : formatNumber(row.costPerUnitFarmer)}
                            </td>
                            <td>
                              {editIndex === idx
                                ? editRowData.totalCostCompany
                                : formatNumber(row.totalCostCompany)}
                            </td>
                            <td>
                              {editIndex === idx
                                ? editRowData.totalCostFarmer
                                : formatNumber(row.totalCostFarmer)}
                            </td>
                            <td>
                              {editIndex === idx
                                ? editRowData.markupValue
                                : formatNumber(row.markupValue)}
                            </td>
                            {/* Actions */}
                            <td>
                              {editIndex === idx ? (
                                <>
                                  <button
                                    className="btn btn-sm"
                                    onClick={handleSaveEdit}
                                    type="button"
                                  >
                                    <i className="fas fa-check" />
                                  </button>
                                  &nbsp;
                                  <button
                                    className="btn btn-sm condary"
                                    onClick={() => setEditIndex(null)}
                                    type="button"
                                  >
                                    <i className="fas fa-times" />
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="btn btn-sm"
                                    onClick={() => handleEditClick(idx)}
                                    type="button"
                                  >
                                    <i className="fas fa-edit" />
                                  </button>
                                  &nbsp;
                                  <button
                                    className="btn btn-sm"
                                    onClick={() => handleDeleteRow(idx)}
                                    type="button"
                                  >
                                    <i className="fas fa-trash" />
                                  </button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12"> 
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </section>
      </div>
    </>
  );
};

export default BudgetTemplateForm;